import { UseAthleteOverview } from "@/components/athlete-overview-page/athlete-overview-page-provider";
import { Pagination } from "@digdir/designsystemet-react";
import { useEffect, useState } from "react";

export function AthleteTablePagination() {
    const { data, updateSearchParams } = UseAthleteOverview()
    const { athleteTable } = data
    const { totalPages, currentPage } = athleteTable.pagination
    const [isMobile, setIsMobile] = useState(false);
    const setCurrentPage = (page: number) => {
        if (page === 0 || page === totalPages + 1 || page === currentPage) return
        updateSearchParams({ page })
    };

    useEffect(() => {
        const mediaQuery = window.matchMedia("(max-width: 767px)");
        const updateShowPages = () => setIsMobile(mediaQuery.matches);

        updateShowPages();
        mediaQuery.addEventListener("change", updateShowPages);

        return () => mediaQuery.removeEventListener("change", updateShowPages);
    }, [window.matchMedia("(max-width: 767px)")]);


    return (
        <div className="w-full flex justify-center items-center pt-4">
            <Pagination>
                <Pagination.List>
                    <Pagination.Item>
                        <Pagination.Button disabled={currentPage === 1} aria-label='Forrige side'
                            className="!bg-transparent text-main-base"
                            onClick={() => setCurrentPage(currentPage - 1)}
                        >
                            <span className="hidden sm:block">Forrige</span>
                        </Pagination.Button>
                    </Pagination.Item>

                    {!isMobile && (currentPage - 1) > 1 && (
                        <>
                            <Pagination.Item>
                                <Pagination.Button aria-label='Side 1' className="!bg-transparent text-main-base"
                                    onClick={() => setCurrentPage(1)}>
                                    1
                                </Pagination.Button>
                            </Pagination.Item>

                            <Pagination.Item className='!hidden sm:!block' />
                        </>
                    )}
                    {currentPage !== 1 && (
                        <Pagination.Item>
                            <Pagination.Button aria-label='Side 1' className="!bg-transparent text-main-base"
                                onClick={() => setCurrentPage(currentPage - 1)}>
                                {currentPage - 1}
                            </Pagination.Button>
                        </Pagination.Item>
                    )}

                    <Pagination.Item>
                        <Pagination.Button aria-label='Side 1'>
                            {currentPage}
                        </Pagination.Button>
                    </Pagination.Item>
                    {currentPage !== totalPages && (

                        <Pagination.Item>
                            <Pagination.Button aria-label='Side 1' className="!bg-transparent text-main-base"
                                onClick={() => setCurrentPage(currentPage + 1)}>
                                {currentPage + 1}
                            </Pagination.Button>
                        </Pagination.Item>
                    )}
                    {!isMobile && (currentPage + 1) < totalPages && (
                        <>
                            <Pagination.Item className='!hidden sm:!block' />
                            <Pagination.Item>
                                <Pagination.Button aria-label='Side 1' className="!bg-transparent text-main-base"
                                    onClick={() => setCurrentPage(totalPages)}>
                                    {totalPages}
                                </Pagination.Button>
                            </Pagination.Item>
                        </>
                    )}

                    <Pagination.Item>
                        <Pagination.Button disabled={currentPage === totalPages} aria-label='Neste side'
                            className="!bg-transparent text-main-base"
                            onClick={() => setCurrentPage(currentPage + 1)}>
                            <span className="hidden sm:block">Neste</span>

                        </Pagination.Button>
                    </Pagination.Item>
                </Pagination.List>
            </Pagination>
        </div>
    );
}
